// Path: src\Components\CommonFields\Textfieldwithbutton.jsx
import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';

const TextFieldWithButton = ({
  label,            // Default label
  placeholder,      // Default placeholder
  value,
  onChange,
  buttonText,       // Default button text
  onButtonClick,    // Handler for button click
  readOnly = false, // Optionally make the field read-only
  showButton = true, // Control whether to show the button,
  minLength,
  maxLength
}) => {
  return (
    <TextField
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      InputProps={{
        readOnly: readOnly,
        endAdornment: showButton ? (
          <InputAdornment position="end">
            <Button
              aria-label="button"
              className="custom-add-button"
              onClick={onButtonClick}
              style={{ borderRadius: '20px' }}  // Border-radius as per your requirement
            >
              {buttonText}
            </Button>
          </InputAdornment>
        ) : null, // Render nothing if showButton is false
      }}
      inputProps={{
        minLength: minLength,
        maxLength: maxLength
      }}  // Add minLength and maxLength here
    />
  );
};

export default TextFieldWithButton;
